import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import useAxiosPrivate from '../../hooks/useAxiosPrivate'

const LoadingPage = () => {
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const [quizResponse, setQuizResponse] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  const encryptedQuizId = localStorage.getItem("quizid");
  const encryptedParticipantEmail = localStorage.getItem("participantEmail");

  useEffect(() => {
    const fetchQuizDetails = async () => {
      try {
        const response = await axiosPrivate.post("/participate/start", {
          encryptedQuizId,
          encryptedParticipantEmail,
        });

        setQuizResponse(response.data);
        setError("");
        setLoading(false);

      } catch (err) {
        handleRequestError(err);
      }
    };

    fetchQuizDetails();
  }, [axiosPrivate, encryptedQuizId, encryptedParticipantEmail]);

  const handleRequestError = (err) => {
    console.error(err);
    if (err?.response?.status === 400) {
      setError("Invalid or missing parameters");
    } else if (err?.response?.status === 401) {
      setError("Invalid or missing authorization token");
    } else if (err?.response?.status === 500) {
      setError("Failed to start the quiz due to an internal error");
    } else {
      setError(err?.response?.data?.message || err?.message);
    }
    setLoading(false);
  }

  return (
    <div className="fade-in" style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      background: "var(--bg-dark)"
    }}>
      {loading ? (
        <div style={{ textAlign: "center" }}>
          <div className="spin" style={{
            fontSize: "4rem",
            marginBottom: "1.5rem",
            display: "inline-block"
          }}>
            ⏳
          </div>
          <h2 style={{
            fontSize: "1.5rem",
            fontWeight: "600",
            background: "linear-gradient(135deg, var(--primary-purple-light), var(--accent-cyan))",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text"
          }}>
            Preparing Assessment...
          </h2>
          <p style={{ color: "var(--text-muted)", marginTop: "0.5rem" }}>
            Please wait while we load your questions
          </p>
        </div>
      ) : (
        <div style={{ textAlign: "center", maxWidth: "500px", padding: "2rem" }}>
          {error ? (
            <div className="card" style={{ padding: "2rem", borderColor: "var(--error-red)" }}>
              <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>⚠️</div>
              <h3 style={{ color: "var(--error-red)", marginBottom: "1rem", fontSize: "1.25rem", fontWeight: "bold" }}>
                Unable to Start Assessment
              </h3>
              <p style={{ color: "var(--text-secondary)", marginBottom: "1.5rem" }}>
                {error}
              </p>
              <button
                className="btn-secondary"
                onClick={() => navigate(-1)}
              >
                Go Back
              </button>
            </div>
          ) : (
            <div className="card" style={{ padding: "2rem", borderColor: "var(--success-green)" }}>
              <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>✅</div>
              <h3 style={{ color: "var(--success-green)", marginBottom: "1rem", fontSize: "1.25rem", fontWeight: "bold" }}>
                Ready to Start!
              </h3>
              <p style={{ color: "var(--text-secondary)" }}>
                Redirecting to assessment...
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default LoadingPage